const cognitoAuthConfig = {
    authority: "https://cognito-idp.us-east-2.amazonaws.com/us-east-2_2vcDUMkMK",
    client_id: "5l6vg6q4otpl18qlk37hrk27kn",
    redirect_uri: process.env.REACT_APP_REDIRECT_URI || "http://localhost:3000",
    response_type: "code",
    scope: "email openid",
  };
  
  export default cognitoAuthConfig;